import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 16px;
`
